<div>
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" name="dashboardSpinner" size="large" color="var(--WhiteColor)" type="timer"
        [fullScreen]="true">
        @if (loadingSpinnerService.currentMessage) {
            <p class="loading-text">{{ loadingSpinnerService.currentMessage }}</p>
        } @else {
            <p class="loading-text">{{'NGX_SPINNER_LOADING' | translate}}</p>
        }
    </ngx-spinner>
</div>
<router-outlet></router-outlet>